export enum AlignmentTypes {
    "right" = "align_right",
    "center" = "align_center",
    "left" = "align_left"
}